import { Platform, StyleSheet } from "react-native";

export const TAB_BAR_HEIGHT = Platform.OS === 'ios' ? 95 : 83;

export const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: "stretch",
        justifyContent: "flex-start",
        backgroundColor: "white"
    },
    textArea: {
      fontSize: 18,
      fontFamily: "ViaodaLibre-Regular",
      paddingVertical: 6,
      borderWidth: 0,
      borderRadius: 10,
      backgroundColor: "#F0F4F9",
      padding: 5,
    },
    bgImageContainer: {
        width: "100%",
        flex: 1,
    },
    whiteViewBgImageContainer: {
        position: "absolute",
        top: 76,
        right: 0
    },
    whiteViewContainer: {
        flex: 1,
        justifyContent: "space-between",
        paddingVertical: 24
    },
    mainViewContainer: {
        flex: 1,
        backgroundColor: "rgba(56, 123, 181, 0.7)",
        paddingHorizontal: 24
    },
    mainViewTitleText: {
        color: "white",
        fontSize: 60,
        lineHeight: 70,
        textAlign: "left",
        fontFamily: "ViaodaLibre-Regular"
    },
    whiteViewTitleText: {
        color: "#242424",
        fontSize: 60,
        lineHeight: 70,
        textAlign: "left",
        fontFamily: "ViaodaLibre-Regular",
        paddingHorizontal: 24,
        marginBottom: 20,
        whiteSpace: "normal"
},
    mainViewWelcomeText: {
        color: "white",
        fontSize: 26,
        lineHeight: 40,
        textAlign: "left",
        fontFamily: "Arsenal-Regular",
        marginLeft: 6
    },
    headerView: {
        position: "absolute",
        width: "100%",
        top: 56,
        alignItems: "flex-start",
        zIndex: 1000
    },
    whiteViewHeaderView: {
        flexDirection: "row",
        marginTop: 30,
        marginBottom: 13,
        alignItems: "center",
        justifyContent: "space-between",
        paddingHorizontal: 24,
        zIndex: 1000
    },
    whiteViewHeaderMenuView: {
        flexDirection: "column",
        position: "absolute",
        right: 24,
        top: 35,
        backgroundColor: "white",
        shadowColor: "black",
        shadowOpacity: 0.15,
        shadowRadius: 7,
        shadowOffset: {width: 1, height: 2},
        elevation: 20,
        borderRadius: 10,
        paddingHorizontal: 16,
        paddingTop: 15,
        paddingBottom: 18
    },
    logoutButton: {
        width: 22
    },
    backButton: {
        width: 26
    },
    mainViewHeaderText: {
        flex: 1,
        color: "white",
        fontSize: 26,
        lineHeight: 45,
        textAlign: "center",
        fontFamily: "ViaodaLibre-Regular",
        marginRight: 22
    },
    whiteViewHeaderText: {
        flex: 1,
        color: "#242424",
        fontSize: 26,
        lineHeight: 45,
        textAlign: "center",
        fontFamily: "ViaodaLibre-Regular",
        marginRight: 26
    },
    whiteViewScrollView: {
        flex: 1
    },
    whiteViewScrollViewInnerContainer: {
        paddingHorizontal: 24,
        flex: 1
    },
    whiteViewScrollViewInnerContainer2: {
        paddingHorizontal: 24,
    },
    login: {
        mainViewContainer: {
            flex: 1,
            backgroundColor: "rgba(56, 123, 181, 0.7)",
            paddingHorizontal: 24
        },
        inputContainer: {
            height: 74
        },
        input: {
            fontSize: 20,
            lineHeight: 20,
            height: 34,
            marginBottom: 10,
            borderWidth: 0,
            borderBottomWidth: 1,
            padding: 0,
            color: "white",
            borderColor: "white",
            fontFamily: "Arsenal-Regular"
        },
        buttonContainer: {
            alignItems: "flex-end"
        },
        button: {
        width: "100%",
        height: 48,
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        borderColor: "white",
        borderWidth: 0.5,
        borderRadius: 60,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: 20,
        paddingRight: 50
    },
    arrowLine: {
        height: 1,                 
        backgroundColor: '#EAF1F8',
        flex: 1,                   
        marginLeft: 50,            
        marginRight: -12.5         
    },
    arrowHead: {
        width: 12,                 
        height: 12,
        borderTopWidth: 1,          
        borderRightWidth: 1,        
        borderColor: '#EAF1F8',     
        transform: [{ rotate: '45deg' }], 
        backgroundColor: 'transparent'
    },
        signUpButton: {
            width: "100%",
            marginTop: 12
        },
        signUpButtonText: {
            marginTop: 12,
            fontSize: 18,
            lineHeight: 25,
            textAlign: "center",
            fontFamily: "ViaodaLibre-Regular",
            textDecorationLine: "underline",
            textTransform: "uppercase",
            color: "white",
        },
        showPasswordIcon: {
            position: "absolute",
            right: 0,
            top: 5
        },
        recoverPasswordText: {
            color: "white",
            fontSize: 20,
            lineHeight: 30,
            textAlign: "left",
            fontFamily: "Arsenal-Regular",
            marginBottom: 48,
            marginTop: 16
        }
    },
    signup: {
        input: {
            fontSize: 20,
            lineHeight: 20,
            height: 34,
            marginBottom: 10,
            borderWidth: 0,
            borderBottomWidth: 1,
            padding: 0,
            color: "#242424",
            borderColor: "#E6EDF3",
            fontFamily: "Arsenal-Regular"
        },
    },
    flagIcon: {
        width: 261,
        height: 185
    },
    flagHeaderView: {
        alignItems: "center",
        position: "absolute",
        top: 28,
        width: "100%"
    },
    account: {
        image: {
            width: 99,
            height: 99,
            marginBottom: 13,
            borderRadius: 49
        },
        imageContainer: {
            width: "100%",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
        },
        debtContainer: {
            alignItems: "flex-end",
        },
        debtHeaderRow: {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
            marginBottom: 6,
        },
        debtLabel: {
            fontSize: 24,
            lineHeight: 30,
            color: "#EA1631",
            fontFamily: "Arsenal-Regular",
            textAlign: "right"
        },
        payNowButton: {
            minHeight: 30,
            paddingHorizontal: 14,
            paddingVertical: 6,
            borderRadius: 20,
            backgroundColor: "#3A86C8",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 4,
            marginLeft: 10,
        },
        payNowButtonDisabled: {
            backgroundColor: "#C7D0D8",
        },
        payNowButtonText: {
            fontSize: 14,
            lineHeight: 18,
            color: "white",
            fontFamily: "Arsenal-Regular",
            textTransform: "uppercase",
        },
        accountItemView: {
            width: "100%",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-end",
            minHeight: 26,
            borderBottomWidth: 1,
            borderColor: "rgba(137, 144, 150, 0.1)",
            paddingTop: 18
        },
        accountItemLabel: {
            fontSize: 18,
            lineHeight: 26,
            color: "#899096",
            fontFamily: "Arsenal-Regular",
        },
        accountItemTitle: {
            fontSize: 28,
            lineHeight: 28,
            color: "#222222",
            fontFamily: "Arsenal-Regular",
            textAlign: "right",
            flex: 1
        },
        accountItemText: {
            fontSize: 18,
            lineHeight: 26,
            color: "#222222",
            fontFamily: "Arsenal-Regular",
            textAlign: "right",
            width: "50%",
            flex: 1
        },
        settingsRow: {
            flexDirection: "row",
            alignItems: "center"
        },
        settingsRowText: {
            fontFamily: "Arsenal-Regular",
            textTransform: "uppercase",
            marginLeft: 10,
            fontSize: 16,
            lineHeight: 20,
            color: "#222222",
        },
        paymentModal: {
            flex: 1,
            backgroundColor: "white",
            paddingTop: Platform.OS === 'ios' ? 58 : 34,
        },
        paymentModalHeader: {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            paddingHorizontal: 24,
            paddingBottom: 18,
            borderBottomWidth: 1,
            borderBottomColor: "rgba(137, 144, 150, 0.18)",
        },
        paymentModalTitle: {
            flex: 1,
            color: "#242424",
            fontSize: 34,
            lineHeight: 40,
            fontFamily: "ViaodaLibre-Regular",
            marginRight: 18,
        },
        paymentModalClose: {
            width: 42,
            height: 42,
            alignItems: "center",
            justifyContent: "center",
        },
        paymentModalCloseText: {
            color: "#222222",
            fontSize: 24,
            lineHeight: 30,
            fontFamily: "Arsenal-Regular",
        },
        paymentDebtList: {
            flex: 1,
        },
        paymentDebtListContent: {
            paddingHorizontal: 24,
            paddingVertical: 14,
        },
        paymentDebtRow: {
            minHeight: 78,
            flexDirection: "row",
            alignItems: "center",
            borderBottomWidth: 1,
            borderBottomColor: "rgba(137, 144, 150, 0.14)",
            paddingVertical: 14,
        },
        paymentDebtContent: {
            flex: 1,
            paddingRight: 12,
        },
        paymentDebtTitle: {
            fontSize: 19,
            lineHeight: 24,
            color: "#222222",
            fontFamily: "Arsenal-Regular",
        },
        paymentDebtMeta: {
            fontSize: 14,
            lineHeight: 19,
            color: "#899096",
            fontFamily: "Arsenal-Regular",
            marginTop: 2,
        },
        paymentDebtAmountColumn: {
            alignItems: "flex-end",
            minWidth: 112,
        },
        paymentDebtAmount: {
            fontSize: 20,
            lineHeight: 26,
            color: "#EA1631",
            fontFamily: "Arsenal-Regular",
            textAlign: "right",
        },
        paymentQuantityRow: {
            flexDirection: "row",
            alignItems: "center",
            marginTop: 8,
        },
        paymentQuantityButton: {
            width: 28,
            height: 28,
            borderRadius: 14,
            backgroundColor: "#3A86C8",
            alignItems: "center",
            justifyContent: "center",
        },
        paymentQuantityButtonDisabled: {
            backgroundColor: "#C7D0D8",
        },
        paymentQuantityButtonText: {
            color: "white",
            fontSize: 20,
            lineHeight: 22,
            fontFamily: "Arsenal-Regular",
        },
        paymentQuantityText: {
            minWidth: 28,
            fontSize: 20,
            lineHeight: 26,
            color: "#222222",
            fontFamily: "Arsenal-Regular",
            textAlign: "center",
        },
        paymentEmptyText: {
            fontSize: 18,
            lineHeight: 26,
            color: "#899096",
            fontFamily: "Arsenal-Regular",
            marginTop: 24,
        },
        paymentFooter: {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            paddingHorizontal: 24,
            paddingTop: 16,
            paddingBottom: Platform.OS === 'ios' ? 34 : 20,
            borderTopWidth: 1,
            borderTopColor: "rgba(137, 144, 150, 0.18)",
        },
        paymentTotalLabel: {
            fontSize: 14,
            lineHeight: 18,
            color: "#899096",
            fontFamily: "Arsenal-Regular",
            textTransform: "uppercase",
        },
        paymentTotalValue: {
            fontSize: 28,
            lineHeight: 34,
            color: "#222222",
            fontFamily: "Arsenal-Regular",
        },
        paymentProceedButton: {
            minHeight: 46,
            maxWidth: 190,
            paddingHorizontal: 18,
            paddingVertical: 10,
            backgroundColor: "#3A86C8",
            justifyContent: "center",
            alignItems: "center",
        },
        paymentProceedButtonDisabled: {
            backgroundColor: "#C7D0D8",
        },
        paymentProceedButtonText: {
            color: "white",
            fontSize: 15,
            lineHeight: 19,
            fontFamily: "Arsenal-Regular",
            textAlign: "center",
            textTransform: "uppercase",
        },
    },
    restaurant: {
        menuButton: {
            width: "100%",
            height: 130,
            borderRadius: 15,
            overflow: "hidden",
            justifyContent: "center"
        },
        menuButtonContainer: {
            flex: 1,
            backgroundColor: "rgba(56, 114, 181, 0.25)",
            justifyContent: "center",
        },
        menuButtonText: {
            fontSize: 35,
            lineHeight: 49,
            textAlign: "center",
            fontFamily: "ViaodaLibre-Regular",
            color: "white",
        },
        reservationTitle: {
            fontSize: 35,
            lineHeight: 49,
            fontFamily: "ViaodaLibre-Regular",
            color: "#242424",
            marginTop: 25
        },
        formItemContainer: {
            justifyContent: "space-between",
            height: 111,
            borderBottomWidth: 1,
            borderColor: "#E6EDF3",
        },
        formItemTitle: {
            fontSize: 17,
            lineHeight: 30,
            fontFamily: "Arsenal-Regular",
            color: "#242424",
        },
        formItemValue: {
            fontSize: 40,
            lineHeight: 56,
            fontFamily: "ViaodaLibre-Regular",
            color: "#242424",
            marginTop: 20
        },
        textInputFormItemContainer: {
            marginTop: 41
        },
        input: {
            fontSize: 20,
            lineHeight: 34,
            marginBottom: 10,
            borderWidth: 1,
            borderRadius: 2,
            padding: 12,
            color: "#242424",
            borderColor: "#E6EDF3",
            fontFamily: "Arsenal-Regular",
            backgroundColor: "#F0F4F9"
        },
        select: {
            fontFamily: "ViaodaLibre-Regular",
            fontSize: "40",
            lineHeight:"56",
            color: "#242424",
            height: "10",
            borderWidth: "0",
            padding: "0",
            marginTop: "5"
        },
        dropdownIcon: {
            position: "absolute",
            right: 0,
            top: "50%"
        }
    },
    gym: {
        tileButton: {
            width: "100%",
            height: 286,
            borderRadius: 15,
            overflow: "hidden",
            justifyContent: "center",
            marginBottom: 17
        },
        tileButtonContainer: {
            flex: 1,
            backgroundColor: "rgba(41, 137, 191, 0.2)",
            justifyContent: "center"
        },
        tileButtonTitle: {
            fontSize: 40,
            lineHeight: 56,
            textAlign: "center",
            fontFamily: "ViaodaLibre-Regular",
            color: "white",
        },
        tileButtonText: {
            fontSize: 20,
            lineHeight: 25,
            textAlign: "center",
            fontFamily: "Arsenal-Regular",
            color: "white",
        },
        tileBottomText: {
            position: "absolute",
            width: "100%",
            bottom: 0,
            fontSize: 20,
            lineHeight: 34,
            textAlign: "center",
            fontFamily: "Arsenal-Regular",
            color: "white",
        }
    },
    menu: {
        tileButton: {
            width: "100%",
            height: 156,
            borderRadius: 15,
            overflow: "hidden",
            justifyContent: "center",
            marginBottom: 10
        },
        tileButtonContainer: {
            flex: 1,
            justifyContent: "center",
            paddingLeft: 20
        },
        tileButtonTitle: {
            fontSize: 30,
            lineHeight: 35,
            textAlign: "left",
            fontFamily: "ViaodaLibre-Regular",
            color: "#242424",
        },
        perPersonView: {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            height: 87,
            paddingLeft: 24,
            paddingRight: 35,
            borderRadius: 15,
            marginBottom: 28
        },
        perPersonText: {
            fontSize: 30,
            lineHeight: 35,
            fontFamily: "ViaodaLibre-Regular",
            color: "black",
            textTransform: "uppercase",
        },
        sectionTitle: {
            fontSize: 35,
            lineHeight: 40,
            fontFamily: "ViaodaLibre-Regular",
            color: "#242424",
            marginBottom: 5
        },
        sectionTitleSelected: {
            fontSize: 35,
            lineHeight: 40,
            fontFamily: "ViaodaLibre-Regular",
            color: "#4C88BC",
        },
        itemView: {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            paddingVertical: 10,
            borderBottomWidth: 1,
            borderColor: "#E6EDF3"
        },
        itemTitle: {
            fontSize: 17,
            lineHeight: 21,
            fontFamily: "Arsenal-Regular",
            color: "#242424",
        },
        itemDescription: {
            fontSize: 15,
            lineHeight: 21,
            fontFamily: "Arsenal-Regular",
            color: "#899096"
        },
        itemPrice: {
            fontSize: 18,
            lineHeight: 20,
            fontFamily: "ViaodaLibre-Regular",
            color: "#222222",
        },
        sectionButtonText: {
            fontSize: 15,
            lineHeight: 35,
            fontFamily: "ViaodaLibre-Regular",
            color: "#899096",
        },
        sectionButtonSelected: {
            fontSize: 15,
            lineHeight: 35,
            fontFamily: "ViaodaLibre-Regular",
            color: "#4C88BC",
        }
    },
    centeredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center"
    },
    modalView: {
        flex: 1,
        paddingTop: 112,
        paddingBottom: 56,
        paddingLeft: 48,
        paddingRight: 48,
        alignItems: "stretch",
        justifyContent: "space-between",
        width: "100%"
    },
    modalHeader: {
        fontSize: 46,
        lineHeight: 56,
        textAlign: "left",
        fontFamily: "ViaodaLibre-Regular",
        color: "white",
        marginBottom: 50
    },
    modalText: {
        fontSize: 20,
        lineHeight: 30,
        textAlign: "left",
        fontFamily: "Arsenal-Regular",
        color: "white",
    },
    modalButton: {
        width: "100%",
        height: 48,
        borderRadius: 60,
        borderWidth: 0.5,
        borderColor: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    colorTriangle: {
        position: "absolute",
        width: 45,
        height: 25,
        top: 14,
        left: 15
    },
    activityIndicatorContainer: {
        position: "absolute",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(41, 137, 191, 0.6)"
    },
    whiteActivityIndicatorContainer: {
        position: "absolute",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.6)"
    },
    gymSaunaSubtitle: {
        position: "absolute",
        height: 25,
        top: 129,
        right: 24
    },
    gymSaunaSubtitleText: {
        color: "#3A86C8",
        fontSize: 16,
        lineHeight: 23,
        textAlign: "right",
        fontFamily: "Arsenal-Regular"
    },
    gymSaunaSubtitleNumber: {
        color: "#3A86C8",
        fontSize: 20,
        lineHeight: 23,
        textAlign: "right",
        fontFamily: "Arsenal-Regular"
    },
    errorText: {
        fontSize: 14,
        lineHeight: 14,
        color: "#EA1631",
        fontFamily: "Arsenal-Regular"
    },
    buttonContainer: {
        marginBottom: 24
    },
    button: {
        width: "100%",
        height: 48,
        backgroundColor: "#3A86C8",
        borderRadius: 60,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    buttonText: {
        fontSize: 18,
        lineHeight: 25,
        textAlign: "center",
        fontFamily: "ViaodaLibre-Regular",
        textTransform: "uppercase",
        color: "white",
    },
    menuItem: {
        backgroundColor: "#f9c2ff",
        padding: 20,
        marginVertical: 8
    },
    menuItemTitle: {
        fontSize: 24
    },
    menuSectionHeader: {
        fontSize: 32,
        backgroundColor: "#fff"
    },
    baseModal: {
        gradientView: {
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            width: "100%"
        },
        contentView: {
            width: 280,
            minHeight: 163,
            paddingTop: 29,
            paddingBottom: 20,
            paddingHorizontal: 20,
            backgroundColor: "#FFFFFF",
            borderRadius: 15,
            alignItems: "center",
            justifyContent: "space-between"
        },
        modalText: {
            fontSize: 17,
            lineHeight: 27,
            color: "#242424",
            fontFamily: "Arsenal-Regular",
            textAlign: "center",
            marginBottom: 30
        }
    },
    errorModal: {
        modalHeader: {
            fontSize: 20,
            lineHeight: 30,
            color: "#EA1631",
            fontFamily: "Arsenal-Regular"
        }
    },
    confirmationModal: {
        cancelButton: {
            width: "50%",
            height: 48,
            backgroundColor: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        cancelButtonText: {
            fontSize: 18,
            lineHeight: 25,
            textAlign: "center",
            fontFamily: "ViaodaLibre-Regular",
            textTransform: "uppercase",
            color: "#4C88BC",
        }
    },
    reservationsBox: {
        backgroundColor: '#f7f7f7',
        borderRadius: 16,
        padding: 16,
        marginVertical: 20,
        marginHorizontal: 0,
        shadowColor: '#000',
        shadowOpacity: 0.07,
        shadowRadius: 8,
        shadowOffset: { width: 0, height: 2 },
        elevation: 2,
        minHeight: 80,
    },
    reservationsBoxTitle: {
        fontSize: 22,
        fontFamily: 'ViaodaLibre-Regular',
        color: '#242424',
        marginBottom: 10,
        textAlign: 'left',
    },
    noReservationsText: {
        textAlign: 'center',
        color: '#888',
        fontSize: 16,
        marginVertical: 16,
        fontFamily: 'Arsenal-Regular',
    },
    reservationItemContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#eeeeee', 
        borderRadius: 10,           
        padding: 12,                
        marginBottom: 10,           
        borderBottomWidth: 2, 
        borderColor: '#cfcccc',
    },
    reservationItemInfo: {
        flex: 1,
    },
    reservationItemTitle: {
        fontSize: 17,
        fontFamily: 'Arsenal-Bold',
        color: '#242424',
        marginBottom: 2,
    },
    reservationItemTime: {
        fontSize: 15,
        color: '#4C88BC',
        fontFamily: 'Arsenal-Regular',
    },
    cancelButton: {
        backgroundColor: '#EA1631',
        borderRadius: 20,
        paddingVertical: 6,
        paddingHorizontal: 14,
        marginLeft: 10,
    },
    cancelButtonText: {
        color: 'white',
        fontSize: 14,
        fontFamily: 'Arsenal-Bold',
        textTransform: 'uppercase',
    },
    floatingButtonContainer: {
        position: 'absolute',
        left: 24,
        right: 24,
        bottom: 16,
    },
    datePicker: {
        backdrop: {
            position: 'absolute', 
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)', 
            zIndex: 1, 
        },
        modalContainer: {
            backgroundColor: '#FFFFFF', 
            borderRadius: 15,
            padding: 20,
            width: 340,       
            maxWidth: '90%',  
            alignItems: 'center',
            zIndex: 2,        
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.25,
            shadowRadius: 3.84,
            elevation: 5,
        },
        header: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 20,
            width: '100%'
        },
        headerTitle: {
            fontSize: 20,
            fontFamily: 'ViaodaLibre-Regular',
            color: '#242424',
            fontWeight: 'bold',
        },
        arrowBtn: {
            padding: 10,
        },
        arrowText: {
            fontSize: 24,
            color: '#3A86C8',
            fontWeight: 'bold',
        },
        weekHeader: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: 10,
            width: '100%'
        },
        weekDayText: {
            width: 35,
            textAlign: 'center',
            fontSize: 14,
            color: '#899096',
            fontFamily: 'Arsenal-Regular',
            fontWeight: 'bold',
        },
        calendarBody: {
            marginBottom: 10,
            width: '100%'
        },
        weekRow: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: 8,
        },
        dayCell: {
            width: 35,
            height: 35,
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 17.5,
        },
        selectedDayCell: {
            backgroundColor: '#3A86C8',
        },
        dayText: {
            color: '#242424',
            fontSize: 16,
            fontFamily: 'Arsenal-Regular',
        },
        selectedDayText: {
            color: 'white',
            fontWeight: 'bold',
        },
        footer: {
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center', // <--- QUESTA RIGA ALLINEA I BOTTONI VERTICALMENTE
            marginTop: 15,
            width: '100%',
            paddingTop: 15,
            borderTopWidth: 1,
            borderColor: '#E6EDF3'
        },
        footerBtn: {
            marginLeft: 25,
            padding: 5,
        },
        cancelText: {
            color: '#899096',
            fontSize: 16,
            fontWeight: 'bold',
            textTransform: 'uppercase',
            fontFamily: 'Arsenal-Regular',
        },
        confirmText: {
            color: 'white', // Ho messo white puro per renderlo più leggibile sul blu
            fontSize: 16,
            fontWeight: 'bold',
            textTransform: 'uppercase',
            fontFamily: 'Arsenal-Regular',
        },
        confirmBtn: {
            backgroundColor: '#3A86C8',
            borderRadius: 30,       
            paddingVertical: 8,     
            paddingHorizontal: 20,  
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: 10,
        },
    },
    installLanding: {
        container: {
            flexGrow: 1,
            backgroundColor: '#F0F4F9',
            alignItems: 'center',
            padding: 20,
            paddingTop: 60,
        },
        hero: {
            alignItems: 'center',
            marginBottom: 40,
            maxWidth: 500,
        },
        appName: {
            fontFamily: 'ViaodaLibre-Regular',
            fontSize: 18,
            letterSpacing: 2,
            color: '#899096',
            marginBottom: 10,
            textTransform: 'uppercase',
        },
        title: {
            fontFamily: 'ViaodaLibre-Regular',
            fontSize: 42,
            color: '#3A86C8',
            textAlign: 'center',
            marginBottom: 15,
        },
        subtitle: {
            fontFamily: 'Arsenal-Regular',
            fontSize: 18,
            color: '#555',
            textAlign: 'center',
            lineHeight: 26,
            paddingHorizontal: 20,
        },
        card: {
            backgroundColor: 'white',
            borderRadius: 20,
            padding: 30,
            width: '100%',
            maxWidth: 400,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.08,
            shadowRadius: 15,
            elevation: 5,
            marginBottom: 30,
        },
        cardTitle: {
            fontFamily: 'ViaodaLibre-Regular',
            fontSize: 24,
            color: '#242424',
            marginBottom: 25,
            textAlign: 'center',
        },
        stepBlock: {
            marginVertical: 10,
        },
        stepHeader: {
            flexDirection: 'row',
            marginBottom: 15,
        },
        numberBadge: {
            width: 28,
            height: 28,
            borderRadius: 14,
            backgroundColor: '#3A86C8',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: 12,
            marginTop: 2,
        },
        numberText: {
            color: 'white',
            fontWeight: 'bold',
            fontFamily: 'Arsenal-Bold',
        },
        stepText: {
            flex: 1,
            fontSize: 17,
            fontFamily: 'Arsenal-Regular',
            color: '#333',
            lineHeight: 24,
            marginTop: 5,
        },
        bold: {
            fontFamily: 'Arsenal-Bold',
            fontWeight: 'bold',
            color: '#242424',
        },
        divider: {
            height: 1,
            backgroundColor: '#E6EDF3',
            marginVertical: 20,
        },
        mockSafariBar: {
            backgroundColor: '#F8F8F8',
            borderTopWidth: 1,
            borderColor: '#D1D1D1',
            paddingVertical: 15,
            paddingHorizontal: 30,
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: 10,
            marginHorizontal: 10,
        },
        mockChromeBar: {
            backgroundColor: '#FFFFFF',
            borderBottomWidth: 1,
            borderColor: '#E0E0E0',
            paddingVertical: 12,
            paddingHorizontal: 15,
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: 8,
            elevation: 2,
            marginHorizontal: 10,
        },
        mockMenuRow: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 15,
            backgroundColor: '#F9F9F9',
            borderRadius: 8,
            marginHorizontal: 10,
            borderBottomWidth: 1,
            borderBottomColor: '#EEE'
        },
        mockMenuText: {
            fontSize: 16,
            color: '#333',
            fontFamily: 'Arsenal-Regular',
        },
        iconShareContainer: {
            width: 20,
            height: 20,
            borderWidth: 2,
            borderColor: '#007AFF',
            borderRadius: 3,
            alignItems: 'center'
        },
        iconShareLine: {
            width: 2,
            height: 12,
            backgroundColor: '#007AFF',
            marginTop: -6
        },
        iconShareArrow: {
            width: 8,
            height: 8,
            borderTopWidth: 2,
            borderLeftWidth: 2,
            borderColor: '#007AFF',
            transform: [{ rotate: '45deg' }],
            marginTop: -2
        },
        iconThreeDotsContainer: {
            justifyContent: 'space-between',
            height: 16
        },
        iconDot: {
            width: 4,
            height: 4,
            backgroundColor: '#5F6368',
            borderRadius: 2
        },
        iconAddContainer: {
            width: 24,
            height: 24,
            borderRadius: 5,
            borderWidth: 2,
            borderColor: '#5F6368',
            backgroundColor: '#e5e5e500',
            justifyContent: 'center',
            alignItems: 'center'
        },
        iconAddText: {
            fontSize: 18,
            fontWeight: 'bold',
            color: '#5F6368',
            marginBottom: 5,
        },
        continueButton: {
            paddingVertical: 15,
            paddingHorizontal: 30,
        },
        continueText: {
            color: '#899096',
            fontSize: 16,
            fontFamily: 'ViaodaLibre-Regular',
            textDecorationLine: 'underline',
        },
    }, 
});
